// extracted by mini-css-extract-plugin
export var container = "WhatWeCanDoSection-module--container--1uTjk";
export var title = "WhatWeCanDoSection-module--title--bn6YQ";
export var paragraph = "WhatWeCanDoSection-module--paragraph--3kekO";
export var boxes = "WhatWeCanDoSection-module--boxes--3pVO8";
export var box = "WhatWeCanDoSection-module--box--38K-h";
export var boxText = "WhatWeCanDoSection-module--boxText--2c98z";
export var icon = "WhatWeCanDoSection-module--icon--2nbTh";
export var studyBoxIcon = "WhatWeCanDoSection-module--studyBoxIcon--2qTcg";
export var note = "WhatWeCanDoSection-module--note--3XJ8g";